const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "COMMENTS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "COMMENTS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "COMMENTS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
